export default __webpack_public_path__ + "static/media/community10.a731af95.png";